import { render, staticRenderFns } from "./slotRule.vue?vue&type=template&id=42a8f40e"
import script from "./slotRule.vue?vue&type=script&lang=js"
export * from "./slotRule.vue?vue&type=script&lang=js"
import style0 from "./slotRule.vue?vue&type=style&index=0&id=42a8f40e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports